import Page from '../../page';
import PopinFilter, {MANAGE_POPIN_FILTER_EVENT} from "../popin-filter/popin-filter";

export default class RecipesList extends Page {
    constructor(...args) {
        super(...args);

        this._initTls();

        bindAll(this, [
            '_openPopinFilter',
            '_closePopinFilter'
        ]);

        this._PopinFilter = new PopinFilter();
    }

    bind() {
        this._PopinFilter.on( MANAGE_POPIN_FILTER_EVENT.OPEN, this._openPopinFilter );
        this._PopinFilter.on( MANAGE_POPIN_FILTER_EVENT.CLOSE, this._closePopinFilter );
    }


    _openPopinFilter() {
        if( this.Components.hasOwnProperty( 'Menu' ) ) {
            this.Components['Menu'].hideMenu();
        }
    }

    _closePopinFilter() {
        if( this.Components.hasOwnProperty( 'Menu' ) ) {
            this.Components['Menu'].showMenu();
        }
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/recipes/list/recipes-list.js